/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
import LoginLayout from '../pages/auth/login/LoginLayout';
import Authorize from '../pages/authorize/Authorize';
import Home from '../pages/home/Home';
import LayoutMain from '../pages/layouts/layoutMain';
import ProviderDirectory from '../pages/auth/vendors/InitCreateVendor';
import Providers from '../pages/layouts/layoutMain/Providers';
import SearchProviders from '../pages/layouts/layoutMain/SearchProviders';
import SectionProfile from '../pages/layouts/layoutMain/SectionProfile';
import ProfileMain from '../pages/profileMain';
import Vendor from '../pages/vendor';
import ViewCreateVendor from '../pages/auth/vendors/ViewCreateVendor';
import WarningVendor from '../pages/auth/vendors/WarningVendor';
import ConfirmInvitationPage from '../pages/auth/confirmInvitation/ConfirmInvitationPage';
import JoinCampFirePage from '../pages/joinCampfire/JoinCampfirePage';
import WelcomePage from '../pages/joinCampfire/WelcomePage';

export const routes = [
    {
        path: '/',
        element: (
            <LayoutMain
                leftComponent={<SectionProfile isProfile={true} />}
                component={<ProfileMain />}
            />
        ),
        private: true
    },
    {
        path: '/confirm-invitation/:tokenSalt',
        element: <ConfirmInvitationPage />
    },
    {
        path: '/login',
        element: <LoginLayout />,
        redirect: true
    },
    {
        path: '/authorize',
        element: <Authorize />
    },
    {
        path: '/join-campfire',
        element: <JoinCampFirePage />,
        private: true
    },
    {
        path: '/welcome',
        element: <WelcomePage />,
        private: true
    },
    {
        path: '/profile',
        element: (
            <LayoutMain
                leftComponent={<SectionProfile isProfile={true} />}
                component={<ProfileMain />}
            />
        ),
        private: true
    },
    {
        path: '/vendor',
        element: (
            <LayoutMain
                leftComponent={
                    <>
                        <SearchProviders />
                        <Providers />
                    </>
                }
                component={<Vendor />}
            />
        ),
        private: true
    },
    {
        path: '/home',
        element: (
            <LayoutMain
                leftComponent={<SectionProfile />}
                component={<ProfileMain />}
            />
        ),
        private: true
    },
    {
        path: '/create-vendor',
        element: (
            <LayoutMain
                leftComponent={<SectionProfile />}
                component={<ViewCreateVendor />}
            />
        ),
        private: true
    },
    {
        path: '/warning-vendor',
        element: (
            <LayoutMain
                leftComponent={<SectionProfile />}
                component={<WarningVendor />}
            />
        ),
        private: true
    },
    {
        path: '/provider-directory',
        element: (
            <LayoutMain
                leftComponent={<SectionProfile />}
                component={<ProviderDirectory />}
            />
        ),
        private: true
    }
];
